import { useUpdateLeadClaimRequest } from "@/entities/lead-claim-request/api";
import { LeadRequestStatus } from "@/entities/lead-claim-request/model";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { Ellipsis } from "lucide-react";

interface ActionDropdownProps {
  id: string;
}

export const ActionsDropdown = ({ id }: ActionDropdownProps) => {
  const { mutateAsync } = useUpdateLeadClaimRequest();

  const handleApprove = () => {
    mutateAsync({ id, status: LeadRequestStatus.APPROVED });
  };

  const handleReject = () => {
    mutateAsync({ id, status: LeadRequestStatus.REJECTED });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Ellipsis className="my-auto self-end stroke-previousText" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={handleApprove}>Одобрить</DropdownMenuItem>
        <DropdownMenuItem onClick={handleReject}>Отклонить</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
